import { useTheme } from '@h9/ui-lib';

function useMediaQuery(breakpoint: string) {
    return window.innerWidth < parseInt(breakpoint);
}

export const useMobile = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return isMobile;
}